import { render } from "./MetawebPhysicalModelList.vue?vue&type=template&id=1cdb65a0&ts=true"
import script from "./MetawebPhysicalModelList.vue?vue&type=script&lang=ts"
export * from "./MetawebPhysicalModelList.vue?vue&type=script&lang=ts"

import "./MetawebPhysicalModelList.vue?vue&type=style&index=0&id=1cdb65a0&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__